import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export interface UndoableNotificationSnackbarData {
  message: string;
  cancelLabel: string;
  closeLabel: string;
}

@Component({
  selector: 'app-undoable-notification-snackbar',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  template: `
    <div class="undoable-snackbar">
      <span class="undoable-snackbar-message">{{ data.message }}</span>
      <div class="undoable-snackbar-actions">
        <button
          type="button"
          mat-button
          color="warn"
          class="undoable-snackbar-button undoable-snackbar-cancel"
          (click)="cancelRequested.emit()">
          {{ data.cancelLabel }}
        </button>
        <button
          type="button"
          mat-button
          class="undoable-snackbar-button"
          (click)="closeRequested.emit()">
          {{ data.closeLabel }}
        </button>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .undoable-snackbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 16px;
      width: min(680px, calc(100vw - 48px));
      max-width: 100%;
      box-sizing: border-box;
    }

    .undoable-snackbar-message {
      flex: 1;
      min-width: min(320px, 100%);
      font-size: 14px;
      line-height: 1.4;
    }

    .undoable-snackbar-actions {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      gap: 4px;
      flex-shrink: 0;
      margin-left: auto;
      max-width: 100%;
    }

    .undoable-snackbar-button {
      min-width: 68px;
      height: 32px;
      padding: 0 10px;
      border-radius: 8px;
      color: inherit;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.02em;
      white-space: nowrap;
      flex-shrink: 0;
      justify-content: center;
    }

    .undoable-snackbar-cancel {
      color: var(--mat-sys-error, #d32f2f);
    }

    @media (max-width: 720px) {
      .undoable-snackbar {
        width: min(100%, calc(100vw - 32px));
        gap: 10px;
      }

      .undoable-snackbar-message {
        min-width: 0;
      }

      .undoable-snackbar-actions {
        width: 100%;
      }
    }
  `],
})
export class UndoableNotificationSnackbarComponent {
  @Output() cancelRequested = new EventEmitter<void>();
  @Output() closeRequested = new EventEmitter<void>();

  constructor(@Inject(MAT_SNACK_BAR_DATA) readonly data: UndoableNotificationSnackbarData) {}
}
